module.exports = __webpack_public_path__ + "img/ico-olha.cc00dc16.png";